export * from './no-content.component';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/no-content/index.ts